module.exports = __webpack_public_path__ + "img/ai_default.2259da20.png";